import { render } from "./Moneyr.vue?vue&type=template&id=4eaee67b"
import script from "./Moneyr.vue?vue&type=script&lang=js"
export * from "./Moneyr.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__